var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SecurityCode',{attrs:{"text":"携帯電話番号設定","title":"入力した携帯電話番号のSMSに送られた6桁のセキュリティコードを入力します。"}})}
var staticRenderFns = []

export { render, staticRenderFns }